import React, { useState } from 'react';
import { Quote, ChevronLeft, ChevronRight, Star } from 'lucide-react';
import { testimonials, testimonialPortrait } from '../data/mock';
import { useLang } from '../context/LanguageContext';

export default function TestimonialsSection() {
  const { t } = useLang();
  const [idx, setIdx] = useState(0);
  const tm = testimonials[idx];
  const next = () => setIdx((idx + 1) % testimonials.length);
  const prev = () => setIdx((idx - 1 + testimonials.length) % testimonials.length);  return (
    <section className="py-24 bg-white">
      <div className="max-w-[1280px] mx-auto px-6 grid grid-cols-1 lg:grid-cols-2 gap-14 items-center">
        <div className="relative">
          <div className="absolute -top-6 -left-6 w-48 h-48 dotted-pattern opacity-70 hidden md:block" />
          <div className="relative rounded-xl overflow-hidden">
            <img src={testimonialPortrait} alt="Client" className="w-full h-[480px] object-cover" />
          </div>
          <div className="absolute -bottom-6 -right-6 bg-[#f5b300] rounded-xl px-8 py-6 shadow-xl">
            <p className="text-[40px] font-extrabold text-[#14110f] leading-none">98%</p>
            <p className="text-[12px] uppercase tracking-wider text-[#14110f]/75 mt-1 font-semibold">{t('test.retention')}</p>
          </div>
        </div>

        <div>
          <p className="section-eyebrow mb-4">{t('test.eyebrow')}</p>
          <h2 className="text-[36px] md:text-[44px] leading-[1.1] font-extrabold text-[#14110f]">
            {t('test.titlePre')} <span className="text-[#f5b300]">{t('test.titleAccent')}</span>
          </h2>

          <div className="mt-9 relative">
            <Quote className="absolute -top-2 -left-2 w-16 h-16 text-[#f5b300]/15" />
            <p className="relative text-[18px] md:text-[19px] leading-relaxed text-neutral-700 italic">
              &ldquo;{t(`testimonial.${tm.id}.quote`)}&rdquo;
            </p>
          </div>

          <div className="mt-8 flex items-center justify-between gap-6">
            <div className="flex items-center gap-4">
              <img src={tm.avatar} alt={tm.name} className="w-14 h-14 rounded-full object-cover border-[3px] border-[#f5b300]" />
              <div>
                <p className="font-bold text-[#14110f] text-[16px]">{tm.name}</p>
                <p className="text-[13px] text-neutral-500">{t(`testimonial.${tm.id}.role`)}</p>
                <span className="flex items-center gap-0.5 mt-1 text-[#f5b300]">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-3 h-3 fill-current" />)}
                </span>
              </div>
            </div>
            <div className="flex items-center gap-2">
              <button onClick={prev} aria-label="prev" className="w-11 h-11 rounded-full border border-neutral-200 hover:bg-[#f5b300] hover:border-[#f5b300] hover:text-[#14110f] flex items-center justify-center transition-all">
                <ChevronLeft className="w-5 h-5" />
              </button>
              <button onClick={next} aria-label="next" className="w-11 h-11 rounded-full bg-[#f5b300] hover:bg-[#e0a200] text-[#14110f] flex items-center justify-center transition-all">
                <ChevronRight className="w-5 h-5" />
              </button>
            </div>
          </div>

          <div className="mt-5 flex gap-1.5">
            {testimonials.map((_, i) => (
              <button
                key={i}
                onClick={() => setIdx(i)}
                aria-label={`go to ${i}`}
                className={`h-1.5 rounded-full transition-all ${i === idx ? 'bg-[#f5b300] w-8' : 'bg-neutral-200 w-3 hover:bg-neutral-300'}`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
